const details = "_details_1yj0y_1";
const legalText = "_legalText_1yj0y_2";
const implicit = "_implicit_1yj0y_45";
const styles = {
  details,
  legalText,
  "consent-checkbox": "_consent-checkbox_1yj0y_38",
  implicit,
  "pending-subscription-title": "_pending-subscription-title_1yj0y_50",
  "confirmed-subscription-title": "_confirmed-subscription-title_1yj0y_62",
  "confirmed-subscription": "_confirmed-subscription_1yj0y_62",
  "permission-sign-up": "_permission-sign-up_1yj0y_77",
  "explicit-consent-title": "_explicit-consent-title_1yj0y_82",
  "pending-explicit-consent-title": "_pending-explicit-consent-title_1yj0y_93",
  "explicit-consent-wrapper": "_explicit-consent-wrapper_1yj0y_105",
  "checkbox-indent": "_checkbox-indent_1yj0y_113"
};
export {
  styles as default,
  details,
  implicit,
  legalText
};
//# sourceMappingURL=consents.module.scss.js.map
